<canvas
  class="timeline-canvas"
  [attr.width.px]="width"
  [attr.height.px]="height"
  [style.left.px]="positionInPixels"
  #canvas
></canvas>



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline-canvas/timeline-canvas.component.html